import { useQuery, useQueryClient, type UseQueryOptions } from '@tanstack/react-query';
import type { CertificationRecordsQueryVariables, CertificationsQueryVariables } from '__generated__/graphql';
import useReactQueryBaseKey from 'hooks/react-query/useReactQueryBaseKey/useReactQueryBaseKey';
import {
  useCertificationRecordsRequest,
  type IUseCertificationRecordsRequestResult,
} from './useCertificationRecordsRequest';

export function useCertificationRecordsQueryKey(variables: CertificationsQueryVariables) {
  return [...useReactQueryBaseKey(), 'CertificationRecordsQuery', variables];
}

export const useCertificationRecordsQueryInvalidation = (variables: CertificationsQueryVariables) => {
  const queryKey = useCertificationRecordsQueryKey(variables);
  const client = useQueryClient();

  return () => client.invalidateQueries({ queryKey });
};

export interface IUseCertificationRecordsQueryOptions {
  variables?: CertificationRecordsQueryVariables;
  options?: Partial<UseQueryOptions<IUseCertificationRecordsRequestResult[]>>;
}
export function useCertificationRecordsQuery(props?: IUseCertificationRecordsQueryOptions) {
  const { variables = {}, options = {} } = props || {};

  const request = useCertificationRecordsRequest();
  const queryKey = useCertificationRecordsQueryKey(variables);
  const queryFn = () => request(variables);

  return useQuery<IUseCertificationRecordsRequestResult[]>({
    ...options,
    queryKey,
    queryFn,
  });
}
